<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="仓库">
						<el-select filterable v-model="searchInfo.warehouseId" style="width: 200px" placeholder="请选择" clear 
						@change="warehouseFocus">
							<el-option v-for="it in warehouseList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label="库区">
						<el-select filterable v-model="searchInfo.districtId" style="width: 200px" placeholder="请选择" clear 
						@change="districtFocus">
							<el-option v-for="it in districList" :key="it.id" :value="it.id" :label="it.warehouseAreaName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="库位" class='tiny'>
						<!-- <el-input style="width:200px;" v-model="searchInfo.warehouseLocationName" placeholder="请选择">
						</el-input> -->
						<el-select filterable v-model="searchInfo.LocationId" style="width: 200px" placeholder="请选择" clear >
							<el-option v-for="it in locationList" :key="it.id" :value="it.id" :label="it.warehouseLocationName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商品名称" class='tiny'>
						<el-input style="width:300px;" v-model="searchInfo.pdtName" placeholder="请输入商品名称">
						</el-input>
					</el-form-item>
					<el-form-item label="商品编号" class='tiny'>
						<el-input style="width:200px;" v-model="searchInfo.pdtCode" placeholder="请输入商品编号">
						</el-input>
					</el-form-item>
					<el-form-item label="批次号" class='tiny'>
						<el-input style="width:200px;" v-model="searchInfo.batchNo" placeholder="请输入批次号">
						</el-input>
					</el-form-item>
					<el-form-item label="货物状态" class='tiny'>
						<el-select filterable v-model="searchInfo.stateOfGoodsId" style="width: 200px" placeholder="请选择" clear 
						>
							<el-option v-for="it in stateOfGoodsList" :key="it.id" :value="it.typeKey" :label="it.typeName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="入库日期">
						<div class="block">
							<el-date-picker v-model="timerArr" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button  @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<!-- <el-button type="primary" @click="addCarousel">新增</el-button> -->
					<el-button type="primary" @click="downloadFile"> 导出 </el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%" border>
			
			<el-table-column  prop="warehouseName" label="仓库" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- fixed="left" -->
            <el-table-column  prop="warehouseAreaName" label="库区" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  prop="warehouseLocationName" label="库位" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="pdtName" label="商品名称" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="pdtCode" label="商品编号" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="goodsStatusName" label="货物状态" align="center" width="120" :show-overflow-tooltip="true"
			:formatter="changeGoodsStatus">
			<!-- :formatter="changeGoodsStatus" -->
			</el-table-column>

			<el-table-column  prop="batchNo" label="批次号" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  prop="storageTime" label="入库日期" align="center" width="120" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="num" label="可用库存" align="center" width="100" :show-overflow-tooltip="true">
			</el-table-column>
			  <el-table-column prop="eaNum" label="可用库存EA" align="center" width="100" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="inNum" label="入库中" align="center" width="80" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="outNum" label="出库中" align="center" width="80" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="lockNum" label="冻结数" align="center" width="80" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="lockEaNum" label="冻结数EA" align="center" width="85" :show-overflow-tooltip="true">
			</el-table-column>
             <el-table-column prop="volume" label="体积(m³)" align="center" width="80" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="weight" label="重量(kg)" align="center" width="80" :show-overflow-tooltip="true">
			</el-table-column>
			
		    <!-- <el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true" width="80">
				<template slot-scope="scope">
					<span v-if="scope.row.status==0" style="color:#F56C6C;font-weight: bold;">停用</span>
					<span v-if="scope.row.status==1" style="color:#67C23A;font-weight: bold;">正常</span>
				</template>
			</el-table-column> -->
			<el-table-column prop="memo" label="备注" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="createBy" label="创建人"  align="center" width="120" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateBy" label="修改人"  align="center" width="120"  :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="updateTime" label="修改时间" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column> -->

			<el-table-column fixed="right" label="操作" align="center" :show-overflow-tooltip="true" width="80px">
				<template slot-scope="scope">
					<!-- <el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" style="color:red;" @click="toBlockUp(scope.row.id)"  
					v-if="scope.row.status==1">停用</el-button> 

					<el-button size="small" type="text" style="color:#67C23A;" @click="toStartUsing(scope.row.id)"
					 v-if="scope.row.status==0">启用</el-button>  -->
					<el-button size="small" type="text" @click="freeze(scope.row)">冻结库存</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 冻结 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" title="冻结库存" @close="addDialogClose"
			:close-on-click-modal="false" width="1000px">
			<div style="text-align: center;padding:0 30px">
				<el-form >
					<div style="display: flex;">
						<el-form-item  label="仓库:" style="width:250px" class="no-form-item">
							<span>{{ storeGoodsInfo.warehouseName }}</span>
						</el-form-item>
						<el-form-item  label="客户:" class="no-form-item">
							<span>{{ storeGoodsInfo.customerName }}</span>
						</el-form-item>
					</div>
                    <div style="display: flex;">
						<el-form-item  label="商品编号:" style="width:250px" class="no-form-item">
							<span>{{ storeGoodsInfo.pdtCode }}</span>
						</el-form-item>
						<el-form-item  label="商品名称:" class="no-form-item">
							<span>{{ storeGoodsInfo.pdtName }}</span>
						</el-form-item>
                    </div>
					<div style="display: flex;">
						<el-form-item label="货物状态:" style="width:250px" class="no-form-item">
							<span>{{ storeGoodsInfo.goodsStatusName }}</span>
						</el-form-item>
						<el-form-item label="批次号:" class="no-form-item">
							<span>{{ storeGoodsInfo.batchNo }}</span>
						</el-form-item>
						
					</div>
                    <div style="display: flex;">
						<el-form-item label="可用库存:" style="width:250px" class="no-form-item">
							<span>{{ storeGoodsInfo.num }}</span>
						</el-form-item>
						<el-form-item label="可用库存EA:" class="no-form-item">
							<span>{{ storeGoodsInfo.eaNum }}</span>
						</el-form-item>
                    </div>
					<div style="display: flex;">
						<el-form-item label="入库中:" style="width:250px" class="no-form-item">
							<span>{{ storeGoodsInfo.inNum }}</span>
						</el-form-item>
						<el-form-item label="出库中:" class="no-form-item">
							<span>{{ storeGoodsInfo.outNum }}</span>
						</el-form-item>
                    </div>
					<div style="display: flex;">
						<el-form-item label="冻结数:" style="width:250px" class="no-form-item">
							<span>{{ storeGoodsInfo.lockNum }}</span>
						</el-form-item>
						<el-form-item label="冻结数EA:" class="no-form-item">
							<span>{{ storeGoodsInfo.lockEaNum }}</span>
						</el-form-item>
                    </div>
                    <div style="height:30px;"></div>
					<div style="display: flex;">
						<el-form-item label="选择:" label-width="80px">
							<el-select filterable v-model="freezeSlect" style="width: 120px" placeholder="请选择" clear>
								<el-option :key="1" :value="1" label="冻结"></el-option>
								<el-option :key="0" :value="-1" label="解冻"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="可用数:" label-width="120px">
							<el-input type="text" style="width: 180px;" v-model="freezeNum"
								auto-complete="off" placeholder="请输入可用" @input="freezeNumInput"/>
						</el-form-item>
						<el-form-item label="可用EA数:" label-width="120px">
							<el-input type="text" style="width: 180px;" v-model="freezeEaNum"
								auto-complete="off" placeholder="请输入可用EA" />
						</el-form-item>
					</div>
					
                    <el-form-item label="原因:" label-width="80px">
						<el-input type="textarea" :rows="2" style="width: 720px;" v-model="reason"
							auto-complete="off" placeholder="请输入冻结原因" />
					</el-form-item>
                    <div style="height:20px"></div>
					<el-button type="primary" @click="submit" :loading="addLoading">提交</el-button>
				</el-form>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				expressList: [],
				searchInfo: {},
				timerArr:[],
				sliderlist:{},
				storeGoodsInfo: {
					showStatus:true
				},
				dialogVisibleSwiper: false,
                poupTitle: '',
                addLoading: false,
                editLoading: false,
                
                warehouseId: '',
                districtId: '',
				locationId: '',
				pdtId:'', //商品
                locationList: [],
                warehouseList: [],
                districList: [],
				dataList1: [],
				stateOfGoodsList: [], //货物状态

				freezeNum: '',
				freezeEaNum: '',
				reason: '',
				freezeSlect: 1,
				batchId: '',
				poupBoxGauge: 0,
			}
		},
		methods: {
            changeNull(row, column, cellValue) { //处理数据为null的情况
				if (cellValue) {
					return cellValue;
				} else {
					return "暂无";
				}
			},
			changeGoodsStatus(row, column, cellValue) { //处理货物状态
				if (cellValue) {
				// 	// return cellValue;
				// 	// this.stateOfGoodsList
				// 	let obj = {};
				// 	obj = this.stateOfGoodsList.find((item) => { //这里的userList就是上面遍历的数据源
				// 		return item.typeKey == cellValue; //筛选出匹配数据
				// 	});
				// 	return obj.typeName
					return cellValue
				} else {
					if(row.goodsStatus){
						return row.goodsStatus;
					}else{
						return '暂无'
					}
				}
				
			},
			search() { //查询
				this.page.pageNum = 1;
				this.findPmsUnit()
			},
			empty() { //清空
				this.timerArr = [];
				this.searchInfo = {}
			},
			addDialogClose() {
				this.storeGoodsInfo = {}
			},
			
			//导出
			downloadFile() {
				let data = {
					// ...this.searchInfo,
					// startTime: this.timerArr ? this.timerArr[0] : "",
					// endTime: this.timerArr ? this.timerArr[1] : "",
					warehouseId: this.searchInfo.warehouseId,
					warehouseAreaId: this.searchInfo.districtId,
					warehouseLocationId: this.searchInfo.LocationId,
					pdtName: this.searchInfo.pdtName,
					pdtCode: this.searchInfo.pdtCode,
					goodsStatus: this.searchInfo.stateOfGoodsId,
					batchNo: this.searchInfo.batchNo,
					startTime: this.timerArr ? this.timerArr[0] : "",
					endTime: this.timerArr ? this.timerArr[1] : "",
				};
				// console.log(data);
				this.$api.locationGoodsBatchExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "按商品批次查询" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			findPmsUnit() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
                    warehouseId: this.searchInfo.warehouseId,
					warehouseAreaId: this.searchInfo.districtId,
					warehouseLocationId: this.searchInfo.LocationId,
					pdtName: this.searchInfo.pdtName,
					pdtCode: this.searchInfo.pdtCode,
					goodsStatus: this.searchInfo.stateOfGoodsId,
					batchNo: this.searchInfo.batchNo,
					startTime: this.timerArr ? this.timerArr[0] : "",
					endTime: this.timerArr ? this.timerArr[1] : "",

				}
				this.$api.getLocationGoodsBatchList(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

            },
            warehouseFocus(e){ //仓库选择 - 库区查询
                this.$api.getDistrictListNoParameter({
                    warehouseId: e,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.districList = res.data
					}
				})
            },
            districtFocus(e){ //库区选择 - 库位查询
                this.$api.getLocationListNoParameter({
                    warehouseAreaId: e,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
			},
			inputChange(e) {
				this.dataList1=[]
				this.$api.findgs(this.$encrypt({
					queryParam: e
				})).then(res => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.data.length > 0) {
						res.data.forEach((item,index)=> {
							this.dataList1.push({
								goodsName: item.pdtName,
								goodsId:item.id,
								pdtCode: item.pdtCode,
								unitName: item.unitName,
							})
						})
						// this.flag=true
					} else {
						this.dataList1 = []
					}
					// console.log('dataList1--',this.dataList1)

				})
			},
			goodsClick(e){
				// console.log('234--', e)
			},
			freeze(item){ //冻结库存
				// console.log('弹出数据--', item)
				this.storeGoodsInfo = item;
				this.batchId = item.id;
				this.freezeNum = "";
				this.freezeEaNum = "";
				this.reason = "";
				this.freezeSlect = 1;
				this.$api.findcarsgood(item.pdtId).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.poupBoxGauge = res.data.boxGauge
					}
				})
				this.dialogVisibleSwiper = true;
			},
			freezeNumInput(){
				this.freezeEaNum = Number(this.freezeNum) * this.poupBoxGauge
			},
			// 新增
			addCarousel() {
                this.storeGoodsInfo = {};
                this.poupTitle = '新增';
                this.warehouseId = '';
                this.districtId = '';
				this.dialogVisibleSwiper = true
			},
			// 冻结
			submit() {
				if(this.freezeNum ==0 || this.freezeEaNum==0){
					this.$message.error('提交数量不可以为0');
					return
				}
				this.addLoading = true;
				let data = {
                	batchId: this.batchId,
					changeType:this.freezeSlect,
					num: this.freezeNum,
					eaNum: this.freezeEaNum,
					memo: this.reason
				}
				// console.log(data)
				this.$api.locationGoodsBatchOperation(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findPmsUnit()
						this.dialogVisibleSwiper = false
						
					} else {
						this.$message.error(res.message);
                    }
                    this.addLoading = false;
				})

			},

			// 编辑
			editialogVisible(e) {
                // console.log(e)
                this.storeGoodsInfo = {};
                this.warehouseId = '';
                this.districtId = '';
                this.poupTitle = '编辑';
				this.$api.getWarehouseLocationInfoByID(e).then((res) => {
					if (res.state == 'success') {
                        this.storeGoodsInfo = res.data;
                        this.warehouseId =  res.data.warehouseId;
                        this.districtId = res.data.warehouseAreaId;
                        this.storeGoodsInfo.status = res.data.status == 1 ? true : false;
                        this.warehouseFocus(res.data.warehouseId)
						this.dialogVisibleSwiper = true
				
					}
				})

			},
			// 编辑修改提交
			submitClick() {
                this.editLoading = true;
                // let data = this.storeGoodsInfo
                let data = {
					 warehouseId: this.warehouseId,
                    warehouseAreaId: this.districtId,
					warehouseLocationCode: this.storeGoodsInfo.warehouseLocationCode,
                    warehouseLocationName: this.storeGoodsInfo.warehouseLocationName,
                    warehouseLocationType: this.storeGoodsInfo.warehouseLocationType,
                    useType: this.storeGoodsInfo.useType,

                    warehouseLocationVolume: this.storeGoodsInfo.warehouseLocationVolume,
                    warehouseLocationWeight: this.storeGoodsInfo.warehouseLocationWeight,
                    warehouseLocationLength: this.storeGoodsInfo.warehouseLocationLength,
                    warehouseLocationWidth: this.storeGoodsInfo.warehouseLocationWidth,

                    status: this.storeGoodsInfo.status ? 1 : 0,
                    memo: this.storeGoodsInfo.memo,

                    id: this.storeGoodsInfo.id
				}
				this.$api.updateWarehouseLocationInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwiper = false
						this.findPmsUnit();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
                    }
                    this.editLoading = false;
				})

			},
			// 停用
			toBlockUp(e) {
				// console.log(e)
				var str = "此操作将停用该库位, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.locationDisableAndEnable(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			// 启用
			toStartUsing(e) {
				// console.log(e)
				var str = "此操作将启用该库位, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.locationDisableAndEnable(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findPmsUnit();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findPmsUnit()
            },
            getWarehouseLis(){
                this.$api.getWarehouseListNoParameter({
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.warehouseList = res.data
					}
				})
			},
			getStateOfGoodsListI(){ //货物状态查看
                this.$api.getStateOfGoodsList().then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.stateOfGoodsList = res.data
					}
				})
			},
		},
		created() {
			// this.findPmsUnit()
			this.getWarehouseLis()
			this.getStateOfGoodsListI()
		}
	}
</script>

<style>
.el-form-item__content{
	margin: 0 !important;
}
.no-form-item{
	margin-bottom: 0 !important;
}
</style>
